import { apiRequest } from './client';
import type {
  CreateStoreInput,
  StoreResponse,
  StoresResponse,
  StoreUsersResponse,
  UpdateStoreInput,
} from '../types/stores';

export function getStores(): Promise<StoresResponse> {
  return apiRequest<StoresResponse>('/api/stores');
}

export function getStore(storeId: string): Promise<StoreResponse> {
  return apiRequest<StoreResponse>(`/api/stores/${storeId}`);
}

export function createStore(input: CreateStoreInput): Promise<StoreResponse> {
  return apiRequest<StoreResponse>('/api/stores', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export function updateStore(
  storeId: string,
  input: UpdateStoreInput,
): Promise<StoreResponse> {
  return apiRequest<StoreResponse>(`/api/stores/${storeId}`, {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}

export function setStoreActive(
  storeId: string,
  isActive: boolean,
): Promise<StoreResponse> {
  return apiRequest<StoreResponse>(`/api/stores/${storeId}/activate`, {
    method: 'PATCH',
    body: JSON.stringify({ isActive }),
  });
}

export function getStoreUsers(storeId: string): Promise<StoreUsersResponse> {
  return apiRequest<StoreUsersResponse>(`/api/stores/${storeId}/users`);
}
